export const SERVER_ERROR = {
  title: "Operation failed",
  description: 'Got server error. Kindly contact WPV team.',
  eventName: 'Go back',
  showModal: true,
  type: 'error'
};

export const LOGIN_ERROR = {
  title: "You are logged out.",
  description: 'You need to login again.',
  eventName: 'Login',
  showModal: true,
  type: 'logout'
};
